import { toast } from "sonner";

export function submitMailto({ to = "sales@rxn3d.com", subject, body, testLabel }) {
  const url = `mailto:${to}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
  try {
    // eslint-disable-next-line no-console
    console.log(`[Rxn3D form → ${testLabel || "mail"}]`, { to, subject, body });
    window.location.href = url;
    toast.success("Opening your email client…", {
      description: "We prefilled the message. Your default mail app will take it from here.",
    });
  } catch (e) {
    toast.error("Couldn’t open email client.", {
      description: "Please use the contact form on our website instead.",
    });
  }
}
